import type { FooterColumn, NavLink } from "@/types/catalog";
import { categoryPath, homePath, searchPath } from "@/lib/routes";

export const utilityLinks = [
  { label: "Find a store", href: "#" },
  { label: "Delivery & Click & Collect", href: "#" },
  { label: "Help", href: "#" },
];

export const mainNavLinks: NavLink[] = [
  { label: "Home & Living", href: categoryPath("home-living") },
  { label: "Women", href: categoryPath("womens-clothing") },
  { label: "Men", href: categoryPath("mens-clothing") },
  { label: "Kids & Baby", href: categoryPath("kids-baby") },
  { label: "Toys", href: categoryPath("toys") },
  { label: "Tech & Gaming", href: categoryPath("tech-gaming") },
  { label: "Beauty", href: categoryPath("beauty") },
  { label: "Sports & Outdoor", href: categoryPath("sports-outdoor") },
  { label: "Garden", href: categoryPath("garden") },
  { label: "New & Offers", href: searchPath("offers") },
  { label: "Easter", href: searchPath("easter") },
];

export const storeBarLinks = [
  { label: "Track your order", href: "#" },
  { label: "Flybuys", href: "#" },
  { label: "Gift cards", href: "#" },
  { label: "Kmart app", href: "#" },
];

export const footerQuickLinks = [
  { label: "Track My Order", href: "#" },
  { label: "Contact Us", href: "#" },
  { label: "Catalogue", href: "#" },
];

export const footerColumns: FooterColumn[] = [
  {
    title: "Customer Help",
    links: [
      { label: "Help & FAQ", href: "#" },
      { label: "Returns", href: "#" },
      { label: "Delivery", href: "#" },
      { label: "Product Recalls", href: "#" },
    ],
  },
  {
    title: "Services & Payment",
    links: [
      { label: "Click & Collect", href: "#" },
      { label: "Gift Cards", href: "#" },
      { label: "Afterpay", href: "#" },
      { label: "Zip Pay", href: "#" },
    ],
  },
  {
    title: "About Kmart",
    links: [
      { label: "About us", href: "#" },
      { label: "Careers", href: "#" },
      { label: "Sustainability", href: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms & Conditions", href: "#" },
    ],
  },
];

export const footerSocialLinks = [
  { label: "Instagram", href: "#" },
  { label: "YouTube", href: "#" },
  { label: "Facebook", href: "#" },
];

export const paymentMethods = [
  "Visa",
  "Mastercard",
  "AMEX",
  "PayPal",
  "Apple Pay",
  "Afterpay",
  "Zip",
];

export const navbarLinks = mainNavLinks.map((link) => ({
  label: link.label,
  href: link.href,
}));

export const footerNavLinks = footerColumns.flatMap((col) =>
  col.links.map((link) => ({ ...link, href: link.href || homePath() })),
);
